// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/modal_image_close.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ModalImage_container__pN\\+66 {
    position: relative;
    width: 100%;
    height: 100%;
    margin: auto;
    /* width: 90vw;
    height: 90vh;
    transform: translateY(5vh); */
}

.ModalImage_img_limit__m-LSn {
    border-radius: 6px;
    transition: opacity 0.3s ease-in-out;
}

.ModalImage_img_limit__m-LSn,
.ModalImage_video_limit__Z-9E0 {
    /* position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    vertical-align: middle;
    max-width: 100%;
    max-height: 100%; */
}

.ModalImage_video_limit__Z-9E0 {
    /* width: 100%;
    height: 100%; */
}

.ModalImage_close_button__YA0Cq {
    display: none;
    width: 24px;
    height: 24px;
    cursor: pointer;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
}

.ModalImage_img_limit__m-LSn:hover ~ .ModalImage_close_button__YA0Cq {
    display: block;
}

.ModalImage_close_button__YA0Cq:hover {
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ModalImage/index.module.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ;;iCAE6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;;IAEI;;;;;;uBAMmB;AACvB;;AAEA;IACI;mBACe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gFAAyF;AAC7F;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["\n.container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    /* width: 90vw;\n    height: 90vh;\n    transform: translateY(5vh); */\n}\n\n.img_limit {\n    border-radius: 6px;\n    transition: opacity 0.3s ease-in-out;\n}\n\n.img_limit,\n.video_limit {\n    /* position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    vertical-align: middle;\n    max-width: 100%;\n    max-height: 100%; */\n}\n\n.video_limit {\n    /* width: 100%;\n    height: 100%; */\n}\n\n.close_button {\n    display: none;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    background: url('../../../../statics/modal_image_close.png') no-repeat center / 100% 100%;\n}\n\n.img_limit:hover ~ .close_button {\n    display: block;\n}\n\n.close_button:hover {\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ModalImage_container__pN+66`,
	"img_limit": `ModalImage_img_limit__m-LSn`,
	"video_limit": `ModalImage_video_limit__Z-9E0`,
	"close_button": `ModalImage_close_button__YA0Cq`
};
export default ___CSS_LOADER_EXPORT___;
